module.exports = __webpack_public_path__ + "static/media/568.230bbff2.webp";